var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ivan-stub text-center text-muted",staticStyle:{"padding":"50px 24px"}},[_c('h4',{staticStyle:{"color":"#333","margin-bottom":"8px"}},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticStyle:{"font-size":"13px","line-height":"1.6"}},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }